import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './types';

export interface LoginModal {
  isOpen: boolean;
}

const initialState = {} as LoginModal;

export const loginModalSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoginModal: (state, action: PayloadAction<LoginModal>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setLoginModal } = loginModalSlice.actions;

export const selectLoginModalState = (state: RootState) => state.loginModal;

export default loginModalSlice.reducer;
